export default __webpack_public_path__ + "2704e6a36360bccd6c5acc15c291d6a4.png";